import Button from '@components/common/Button';
import React from 'react';
import { ButtonsContainer, StyledDescription, StyledLink } from './UnavailableClosingPositionModal.styles';
import { createOpenseaURL } from 'utils/createOpenseaURL';
import { useActivePositionId } from '@components/store/getters';

const UnavailableClosingPositionModal = () => {
  const positionId = useActivePositionId();
  return (
    <>
      <StyledDescription>
        Don`t worry, your funds are safe. The Curve pools are currently out of balance, so closing a position is
        unavailable. Check back again later, or trade your tokenized position on OpenSea.
      </StyledDescription>
      <ButtonsContainer>
        <StyledLink variant="button" href="https://docs.archimedesfi.com/">
          Read documentation
        </StyledLink>
        <StyledLink variant="button" href={createOpenseaURL(positionId)}>
          View on OpenSea
        </StyledLink>
        <Button variant="outline" onClick={close}>
          Nevermind
        </Button>
      </ButtonsContainer>
    </>
  );
};

export default UnavailableClosingPositionModal;
